import { Factura } from './factura.entity';
import { Respuesta } from './respuesta.entity';

export class FacturasFiltro {
    Facturas: Factura[];
    Login: string;
    ContratoCodigo: number;
    ReturnStatus: boolean;
    Respuesta?: Respuesta;
    TotalPages: number;
    TotalRows: number;
    PageSize: number;
    SortExpression?: any;
    SortDirection?: any;
    CurrentPageNumber: number;
}
